import React, { useState as eS, useEffect as eE } from 'react';
import { Icons as EIc } from './icons.jsx';

const SYNC_ITEMS = [
  { key: "products", label: "Product catalog" },
  { key: "inventory", label: "Inventory levels" },
];

function FinishStep({ state, onEnter, items: itemsProp }) {
  const [pct, setPct] = eS(0);
  const [done, setDone] = eS(false);

  eE(() => {
    let p = 0;
    const id = setInterval(() => {
      p = Math.min(100, p + Math.random() * 9 + 4);
      setPct(Math.round(p));
      if (p >= 100) { clearInterval(id); setTimeout(() => setDone(true), 700); }
    }, 280);
    return () => clearInterval(id);
  }, []);

  const items = itemsProp || [
    { ok: true, label: "Account created & email verified" },
    { ok: !!state.plan, label: "Plan selected" },
    { ok: state.connected, label: state.connected ? "Amazon account connected" : "Amazon connection skipped" },
    { ok: !!state.skus, label: state.skus ? `${state.skus.total} SKUs imported` : "SKU import skipped" },
    { ok: state.mappingUploaded, label: state.mappingUploaded ? "Product & vendor mapping uploaded" : "Mapping skipped" },
    { ok: state.inventoryUploaded, label: state.inventoryUploaded ? "Warehouse inventory uploaded" : "Inventory skipped" },
  ];

  if (!done) {
    const activeIdx = Math.min(SYNC_ITEMS.length - 1, Math.floor(pct / (100 / SYNC_ITEMS.length)));
    return (
      <div className="max-w-3xl mx-auto">
        <div className="onboarding-card text-center">
          <div className="mb-8">
            <EIc.RefreshCw size={64} style={{ color: "var(--onboarding-primary)", margin: "0 auto" }} className="animate-spin-slow" />
          </div>
          <h2 className="text-3xl font-bold text-foreground mb-4">Setting up your MarketOS dashboard</h2>
          <p className="text-muted-foreground text-lg mb-8 font-medium">
            We're finalizing your catalog, inventory and account.
            <br />This usually takes a moment — you'll get an email when everything is ready.
          </p>
          <div className="mb-8">
            <div className="progress-bar" style={{ marginBottom: "16px" }}>
              <div className="progress-fill" style={{ width: `${pct}%` }} />
            </div>
            <p className="text-sm text-muted-foreground font-medium">{SYNC_ITEMS[activeIdx].label}…</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      <div className="onboarding-card text-center">
        <div className="mb-8">
          <EIc.CircleCheck size={80} style={{ color: "var(--onboarding-success)", margin: "0 auto" }} className="animate-pulse-success" />
        </div>
        <h2 className="text-3xl font-bold text-foreground mb-3">Welcome to MarketOS!</h2>
        <p className="text-muted-foreground font-medium text-lg mb-8">
          Your account is ready. You can finish any skipped steps anytime from your dashboard.
        </p>
        <div className="bg-success/10 border-success/20 border rounded-lg p-6 mb-8" style={{ textAlign: "left", maxWidth: "460px", margin: "0 auto 32px" }}>
          {items.map((it, i) => (
            <div key={i} className="flex items-center" style={{ marginBottom: i < items.length - 1 ? "12px" : 0 }}>
              {it.ok
                ? <EIc.CircleCheck size={20} style={{ color: "var(--onboarding-success)", marginRight: "12px", flexShrink: 0 }} />
                : <EIc.Clock size={20} style={{ color: "var(--onboarding-muted-foreground)", marginRight: "12px", flexShrink: 0 }} />}
              <span style={{ fontSize: "14px", fontWeight: 600, color: it.ok ? "var(--onboarding-foreground)" : "var(--onboarding-muted-foreground)" }}>{it.label}</span>
            </div>
          ))}
        </div>
        <button onClick={onEnter} className="btn-primary font-semibold" style={{ height: "44px", padding: "8px 28px" }}>
          Enter MarketOS <EIc.ArrowRight />
        </button>

      </div>
    </div>
  );
}


export { FinishStep };
